import type { IconData } from '@stacksjs/iconify-core'

export const watch1: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M8 24a16 16 0 1 0 32 0a16 16 0 1 0-32 0\"/><path d=\"m13.027 35.645l1.423 5.471c.472 1.817 1.794 3.266 3.652 3.526c1.385.195 3.316.357 5.898.357s4.512-.162 5.897-.357c1.859-.26 3.18-1.71 3.652-3.526l1.423-5.471m0-23.29l-1.423-5.472c-.472-1.816-1.793-3.266-3.652-3.526C28.512 3.163 26.581 3 24 3s-4.513.163-5.898.357c-1.858.26-3.18 1.71-3.652 3.526l-1.423 5.472\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default watch1
